module.exports = __webpack_public_path__ + "static/img/62993626.c2ae2cd8.png";